import { render, staticRenderFns } from "./MdmProfileModal.vue?vue&type=template&id=0a2aee70&lang=pug&"
import script from "./MdmProfileModal.vue?vue&type=script&lang=js&"
export * from "./MdmProfileModal.vue?vue&type=script&lang=js&"
import style0 from "./MdmProfileModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports